import { render } from "./attentionGift.vue?vue&type=template&id=137de2ff&scoped=true"
import script from "./attentionGift.vue?vue&type=script&lang=js"
export * from "./attentionGift.vue?vue&type=script&lang=js"

import "./attentionGift.vue?vue&type=style&index=0&id=137de2ff&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-137de2ff"]])

export default __exports__